<template>
  
  <div class="catalogo-login" style="overflow: hidden;">
    <CatalogoHeader 
      :logo="logo" 
      :search="search"
      :advancedFilters="catalogoFiltros"
      :filters="filters" 
      :filtroMenuHorizontal="filtroMenuHorizontal" 
      @buscar="buscarCatalogo"
      @limparBusca="limparBuscaCatalogo"
      @selecionarFiltro="selecionarFiltro"
      @goToLogin="goToLogin"
      @goToSignin="goToSignin"
    />

    <div class="row ma-0" style="height: calc(100vh - 9rem);">

      <FiltroAtributos
        class="coluna-direita hide-on-small-only"
        :filtrosDaBusca="filtrosDaBusca"
        :filtrosSelecionados="filtrosSelecionados"
        :filters="filters"
        @filtrarProdutos="filtrarProdutos"
        @limparGrupo="limparGrupo"
      />

      <!-- Coluna central do layout -->
      <div class="col s12 m8 ma-0 pa-0 pl-1 pr-1" style="margin-top: 20px; height: calc(100% - 5rem); overflow: auto;">
        <div class="row" style="margin-bottom:0 !important;">
          <st-carousel
            class="stCarousel"
            :env="env"
            :usuario="null"
            inCatalogo
          />
        </div>

        <ListaProdutos
          :produtos="produtosFiltrados"
          :primaryColor="primaryColor"
          @comprar="comprar"
        />
      </div>

      <!-- Coluna esquerda do layout -->
      <div class="hide-on-small-only col s2 pa-0"></div>
      
      <Paginacao
        :paginaAtual="paginaAtual"
        :totalPaginas="totalPaginas"
        :totalRegistros="totalRegistros"
        :itensVisiveis="produtosFiltrados.length"
        @mudarPagina="mudarPagina"
      />

    </div>
  </div>
</template>

<script>
import StHelper from '../../helpers/StHelper';
import stCarousel from '../../shared/stCarousel/stCarousel.vue';
import CatalogoHeader from './CatalogoHeader.vue';
import FiltroAtributos from './FiltroAtributos.vue';
import ListaProdutos from './ListaProdutos.vue';
import Paginacao from './Paginacao.vue';

export default {
  components: {
    stCarousel,
    CatalogoHeader,
    FiltroAtributos,
    ListaProdutos,
    Paginacao,
  },
  name: 'catalogo-login',
  props: {
    env: { type: Object, default: null },
    logo: { type: String, default: null },
    tema: { type: String, default: null } 
  },
  data() {
    return {
      filters: [],
      emprId: 1,
      cateId: 1,
      search: null, 
      catalogoFiltros: {
        marca: '',
        montadora: '',
        grupo: '',
        descricao: '',
        aplicacao: ''
      },
      productList: [],
      ultimoAccordion: null,
      checkedFilters: [],
      filtrosDaBusca: {
        atributo_1: [],
        atributo_2: [],
        atributo_3: [],
        atributo_4: [],
        atributo_6: []
      },
      filtrosSelecionados: {
        atributo_1: [],
        atributo_2: [],
        atributo_3: [],
        atributo_4: [],
        atributo_6: []
      },
      produtosFiltrados: [],
      primaryColor: '#ccc',
      paginaAtual: 1,
      totalPaginas: 1,
      totalRegistros: 0,
      itensPorPagina: 20,
      filtroMenuHorizontal: '',
    }
  },
  updated() {
    StHelper.truncateActive();
    this.definePrimaryColor();
  },
  mounted() {
    $('.collapsible').collapsible();
    this.definePrimaryColor();
  },
  computed: {},
  watch: {},
  created() {
    Promise.resolve()
      .then(() => this.getUnegInfo())
      .then(() => this.initiateDropdown())
      .then(() => this.getProducts())
      .catch(error => console.error('Error during component creation:', error));
    this.loadFiltersOptions(this.emprId)
  },
  methods: {
    getUnegInfo() {
      if (this.tema) {
        this.$http.get('unidadeNegocio/tema/' + this.tema)
        .then(response => response.json())
        .then(data => {
          this.emprId = data.id;
          this.cateId = data.id;
          this.loadFiltersOptions(this.emprId);
        })
        .catch(error => {
          console.error('Error fetching unegocio info:', error);
        });  
      }
    },
    /**
     * @author robson oliveira
     * @since 2.24.06
     * @description Método que efetua a busca dos produtos do catalogo através da API
     * @param {String} search - Termo de pesquisa (com filtros de atributos 1, 2, 3, 4 e 5)
     * */
    getProducts(subMenu = null, pagina = 1) {
      this.limpaFiltrosSelecionados();
      let searchQuery = this.search ? this.search.trim() : '';
      if (subMenu) this.filtroMenuHorizontal = subMenu;

      console.log('Search Query:', searchQuery);
      this.$http.get('item/produtos', {
        params: {
          "id-empresa": this.emprId,
          "id-categoria": this.cateId, 
          "query": searchQuery + (this.filtroMenuHorizontal ? ' ' + this.filtroMenuHorizontal : ''),
          "marca": this.catalogoFiltros.marca,
          "montadora": this.catalogoFiltros.montadora,
          "grupo": this.catalogoFiltros.grupo,
          "descricao": this.catalogoFiltros.descricao,
          "aplicacao": this.catalogoFiltros.aplicacao,
          "exibir-item-sem-foto": false,
          "pagina": pagina,
          "limite": this.itensPorPagina
        }
      })
      .then(rs => rs.json())
      .then(data => {
        this.productList = data;
        this.extrairFiltrosDaBusca(data.itens);
        this.produtosFiltrados = data.itens;
        this.paginaAtual = data.pagina;
        this.totalPaginas = data.totalPaginas;
        this.totalRegistros = data.totalRegistros;

        // 🔍 Destacar termo após carregar os produtos
        this.$nextTick(() => this.highlightSearchTerm(searchQuery))
      })
      .catch(error => console.error(error));
    },
    loadFiltersOptions(emprId) {
      if (!emprId) emprId = 1;

      this.$http.get(`dicionario/opcoes-catalogo/${emprId}`)
        .then(response => response.json())
        .then(data => this.filters = data)
        .then(() => {
          console.log('Filters loaded:', this.filters);
        })
        .then(() => this.initiateDropdown())
        .catch(error => {
          console.error('Error loading filters:', error);
        });
    },
    initiateDropdown() {
      this.$nextTick(() => {
          $('.dropdown-button').dropdown({
            inDuration: 300,
            outDuration: 225,
            constrainWidth: false, // Does not change width of dropdown to that of the activator
            gutter: 5, // Spacing from edge
            belowOrigin: false, // Displays dropdown below the button
            alignment: 'left', // Displays dropdown with edge aligned to the left of button
            stopPropagation: false, // Stops event propagation
          }

        );
      });
    },
    goToLogin(produto = null) {
      this.$emit('goToLogin', produto);
    },
    goToSignin() {
      this.$emit('goToSignin');
    },
    comprar(produto) {
      this.goToLogin(produto);
    },
    buscarCatalogo(searchLocal, filtros) {
      this.search = searchLocal;
      this.catalogoFiltros = Object.assign({}, this.catalogoFiltros, filtros);
      this.filtroMenuHorizontal = null;
      this.getProducts();
    },
    limparBuscaCatalogo(searchLocal, filtros) {
      this.search = searchLocal;
      this.catalogoFiltros = Object.assign({}, this.catalogoFiltros, filtros);
      this.filtroMenuHorizontal = null;
      this.getProducts();
    },
    limparGrupo(subMenus) {
      const checkboxes = this.$el.querySelectorAll('.collapsible input[type="checkbox"]');

      checkboxes.forEach(cb => {
        const label = this.$el.querySelector(`label[for="${cb.id}"]`);
        if (label && subMenus.includes(label.innerText.trim())) {
          cb.checked = false;
        }
      });

      // Limpa os filtrosSelecionados correspondentes
      Object.keys(this.filtrosSelecionados).forEach(key => {
        this.filtrosSelecionados[key] = this.filtrosSelecionados[key].filter(val => !subMenus.includes(val));
      });

      this.filtrarProdutos();
    },
    extrairFiltrosDaBusca(itens) {
      const filtrosTemp = {
        atributo1: new Set(),
        atributo2: new Set(),
        atributo3: new Set(),
        atributo4: new Set(),
        atributo6: new Set()
      };

      itens.forEach(item => {
        if (item.atributo1) filtrosTemp.atributo1.add(item.atributo1);
        if (item.atributo2) filtrosTemp.atributo2.add(item.atributo2);
        if (item.atributo3) filtrosTemp.atributo3.add(item.atributo3);
        if (item.atributo4) filtrosTemp.atributo4.add(item.atributo4);
        if (item.atributo6) filtrosTemp.atributo6.add(item.atributo6);
      });

      this.filtrosDaBusca = {
        atributo_1: Array.from(filtrosTemp.atributo1),
        atributo_2: Array.from(filtrosTemp.atributo2),
        atributo_3: Array.from(filtrosTemp.atributo3),
        atributo_4: Array.from(filtrosTemp.atributo4),
        atributo_6: Array.from(filtrosTemp.atributo6)
      };
    },
    filtrarProdutos() {
      const filtros = this.filtrosSelecionados;
      const produtosOriginais = this.productList.itens || [];

      const filtrados = produtosOriginais.filter(produto => {
        return (
          (filtros.atributo_1.length === 0 || filtros.atributo_1.includes(produto.atributo1)) &&
          (filtros.atributo_2.length === 0 || filtros.atributo_2.includes(produto.atributo2)) &&
          (filtros.atributo_3.length === 0 || filtros.atributo_3.includes(produto.atributo3)) &&
          (filtros.atributo_4.length === 0 || filtros.atributo_4.includes(produto.atributo4)) &&
          (filtros.atributo_6.length === 0 || filtros.atributo_6.includes(produto.atributo6))
        );
      });

      this.produtosFiltrados = filtrados;
    },
    limpaFiltrosSelecionados() {
      this.filtrosSelecionados = {
        atributo_1: [],
        atributo_2: [],
        atributo_3: [],
        atributo_4: [],
        atributo_6: []
      }
    },
    definePrimaryColor() {
      const el = document.querySelector('.primary-color-text');
      this.primaryColor = el && getComputedStyle(el) && getComputedStyle(el).color || '#ccc';
    },
    mudarPagina(novaPagina) {
      if (novaPagina >= 1 && novaPagina <= this.totalPaginas) {
        this.getProducts(null, novaPagina);
      }
    },
    highlightSearchTerm(term) {
      if (!term) return;

      // Remove destaques anteriores
      const highlighted = this.$el.querySelectorAll('.highlighted-search');
      highlighted.forEach(el => {
        const parent = el.parentNode;
        parent.replaceChild(document.createTextNode(el.textContent), el);
        parent.normalize();
      });

      const regex = new RegExp(term, 'gi');

      const walker = document.createTreeWalker(this.$el, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          // Ignora nós que estão dentro de <script>, <style>, ou <noscript>
          const parentTag = node.parentNode.tagName;
          if (['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parentTag)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      const nodesToProcess = [];

      while (walker.nextNode()) {
        if (regex.test(walker.currentNode.nodeValue)) {
          nodesToProcess.push(walker.currentNode);
        }
      }

      nodesToProcess.forEach(node => {
        const parent = node.parentNode;
        const frag = document.createDocumentFragment();
        const parts = node.nodeValue.split(regex);

        let matchIndex = 0;
        parts.forEach((part, i) => {
          frag.appendChild(document.createTextNode(part));
          if (i < parts.length - 1) {
            const match = node.nodeValue.match(regex)[matchIndex++];
            const mark = document.createElement('mark');
            mark.className = 'highlighted-search';
            mark.textContent = match;
            frag.appendChild(mark);
          }
        });

        parent.replaceChild(frag, node);
      });
    },
    selecionarFiltro(sub) {
      this.search = null; 
      this.filtroMenuHorizontal = sub; 
      this.getProducts(sub);
    },
  },
}

</script>


<style lang="scss" scoped>

.coluna-direita .collapsible-body {
  [type="checkbox"].filled-in-box + label:before {
    border: 2px solid var(--primary-color) !important;
  }
  
  [type="checkbox"].filled-in-box:checked + label:before {
    border: unset !important;
    border-right: 2px solid var(--primary-color) !important;
    border-bottom: 2px solid var(--primary-color) !important;
  }
}

.highlighted-search mark {
  background-color: yellow;
  font-weight: bold;
  padding: 0 2px;
}

@media only screen and (max-width: 600px) {
  
}

</style>



// WEBPACK FOOTER //
// CatalogoLogin.vue?c5a6abca